import { lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts and Route Guards
import RootLayout from "./components/layout/RootLayout";
import AuthLayout from "./components/layout/AuthLayout";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import PublicRoute from "./components/layout/PublicRoute";

// Dynamically import views for code-splitting
const Dashboard = lazy(() => import("./views/dashboard"));
const Sessions = lazy(() => import("./views/sessions"));
const ActiveSessions = lazy(() => import("./components/sessions/ActiveSessions"));
const CompletedSessions = lazy(() => import("./components/sessions/CompletedSessions"));
const ResultSummary = lazy(()=>import("./components/sessions/ResultSummary"))
const Configuration = lazy(() => import("./views/configuration"));
const Api = lazy(() => import("./views/api"));
const Settings = lazy(() => import("./views/settings"));
const Login = lazy(() => import("./views/login"));
const Register = lazy(() => import("./views/register"));
const VerifyEmail = lazy(() => import("./views/auth/VerifyEmail"));
const InvitationResponse = lazy(() => import("./views/invitation/InvitationResponse"));

export const AppRoutes = () => {
  return (
    <Routes>
      {/* --- INVITATION ROUTES (ALWAYS ACCESSIBLE) --- */}
      <Route path="/invitations/:token" element={<InvitationResponse />} />
      <Route path="/join-organization/:token" element={<InvitationResponse />} />
      <Route path="/join-invitation/:token" element={<InvitationResponse />} />

      {/* Public routes for users who are NOT authenticated */}
      <Route element={<PublicRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/register" element={<Register />} />
        </Route>
      </Route>

      {/* Protected routes that require authentication */}
       <Route element={<ProtectedRoute />}>
        <Route element={<RootLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/sessions" element={<Sessions />}>
            <Route index element={<Navigate to="active" replace />} />
            <Route path="active" element={<ActiveSessions />} />
            <Route path="completed" element={<CompletedSessions />} />
           
          </Route>
            <Route path="/summary/:sessionId" element={<ResultSummary />} />
          <Route path="/configuration" element={<Configuration />} />
          <Route path="/api" element={<Api />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Route>
    </Routes>
  );
};